module.exports = __webpack_public_path__ + "static/img/animales_19.24ca5857.jpg";